import styled from 'styled-components'
import { ChevronLeftIcon, ChevronRightIcon } from '@nx/fire/assets'

export const LotNavigationContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.fontStyles.sourceSans.medium}
  text-transform: uppercase;

  a {
    display: flex;
    align-items: center;
  }

  ${({ theme }) => theme.media.up.lg} {
    justify-content: flex-end;
  }
`

export const LotNavigationPrevious = styled.div`
  margin-right: 3rem;
  justify-self: start;

  a {
    ${({ theme }) => theme.fontStyles.sourceSans.medium}
  }
`

export const LotNavigationNext = styled.div`
  justify-self: end;

  a {
    ${({ theme }) => theme.fontStyles.sourceSans.medium}
  }
`

export const ChevronLeft = styled(ChevronLeftIcon)`
  height: 25px;
  width: 25px;
  margin-right: 7px;
`

export const ChevronRight = styled(ChevronRightIcon)`
  height: 25px;
  width: 25px;
  margin-left: 7px;
`
